import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { ROLLBACK_VERSION_MODULE } from '../../configs/moduleNames';
import {
  BEGIN, CLEAR, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';

export const ROLLBACK_VERSION = '_ROLLBACK_VERSION';
export const LOAD_APPLICATION_HISTORY_VERSION_LIST = 'LOAD_APPLICATION_HISTORY_VERSION_LIST';
export const CREATE_ROLLBACK_PLANS = '_CREATE_ROLLBACK_PLANS';
export const CHEK_STATUS_ROLLBACK_PLANS = '_CHEK_STATUS_ROLLBACK_PLANS';
export const CHEK_STATUS_ROLLBACK_PLANS_LOOP = '_CHEK_STATUS_ROLLBACK_PLANS_LOOP';
export const LOAD_ROLLBACK_PLANS = '_LOAD_ROLLBACK_PLANS';
export const LOAD_LOG_ROLLBACK_VERSION = '_LOAD_LOG_ROLLBACK_VERSION';

export const checkStatusRollbackVersion = createDeferredAction(ROLLBACK_VERSION_MODULE + CHEK_STATUS_ROLLBACK_PLANS);
export const checkStatusRollbackVersionSuccessful = createAction(ROLLBACK_VERSION_MODULE + CHEK_STATUS_ROLLBACK_PLANS + SUCCESSFUL);
export const checkStatusRollbackVersionFailed = createAction(ROLLBACK_VERSION_MODULE + CHEK_STATUS_ROLLBACK_PLANS + FAILED);

export const checkStatusRollbackPlansLoop = createDeferredAction(ROLLBACK_VERSION_MODULE + CHEK_STATUS_ROLLBACK_PLANS_LOOP);
export const checkStatusRollbackPlansLoopSuccessful = createAction(ROLLBACK_VERSION_MODULE + CHEK_STATUS_ROLLBACK_PLANS_LOOP + SUCCESSFUL);
export const checkStatusRollbackPlansLoopFailed = createAction(ROLLBACK_VERSION_MODULE + CHEK_STATUS_ROLLBACK_PLANS_LOOP + FAILED);

export const createRollbackPlans = createDeferredAction(ROLLBACK_VERSION_MODULE + CREATE_ROLLBACK_PLANS);
export const createRollbackPlansBegin = createDeferredAction(ROLLBACK_VERSION_MODULE + CREATE_ROLLBACK_PLANS + BEGIN);
export const createRollbackPlansSuccessful = createAction(ROLLBACK_VERSION_MODULE + CREATE_ROLLBACK_PLANS + SUCCESSFUL);
export const createRollbackPlansFailed = createAction(ROLLBACK_VERSION_MODULE + CREATE_ROLLBACK_PLANS + FAILED);

export const rollbackVersion = createDeferredAction(ROLLBACK_VERSION_MODULE + ROLLBACK_VERSION);
export const rollbackVersionSuccessful = createAction(ROLLBACK_VERSION_MODULE + ROLLBACK_VERSION + SUCCESSFUL);
export const rollbackVersionFailed = createAction(ROLLBACK_VERSION_MODULE + ROLLBACK_VERSION + FAILED);

export const loadLogRollbackVersion = createDeferredAction(ROLLBACK_VERSION_MODULE + LOAD_LOG_ROLLBACK_VERSION);
export const loadLogRollbackVersionSuccessful = createAction(ROLLBACK_VERSION_MODULE + LOAD_LOG_ROLLBACK_VERSION + SUCCESSFUL);
export const loadLogRollbackVersionFailed = createAction(ROLLBACK_VERSION_MODULE + LOAD_LOG_ROLLBACK_VERSION + FAILED);

export const loadVersionList = createDeferredAction(ROLLBACK_VERSION_MODULE + LOAD_APPLICATION_HISTORY_VERSION_LIST);
export const loadVersionListBegin = createDeferredAction(ROLLBACK_VERSION_MODULE + LOAD_APPLICATION_HISTORY_VERSION_LIST + BEGIN);
export const loadVersionListSuccessful = createAction(ROLLBACK_VERSION_MODULE + LOAD_APPLICATION_HISTORY_VERSION_LIST + SUCCESSFUL);
export const loadVersionListFailed = createAction(ROLLBACK_VERSION_MODULE + LOAD_APPLICATION_HISTORY_VERSION_LIST + FAILED);
export const loadVersionListClear = createDeferredAction(ROLLBACK_VERSION_MODULE + LOAD_APPLICATION_HISTORY_VERSION_LIST + CLEAR);

export const loadRollbackPlans = createDeferredAction(ROLLBACK_VERSION_MODULE + LOAD_ROLLBACK_PLANS);
export const loadRollbackPlansBegin = createDeferredAction(ROLLBACK_VERSION_MODULE + LOAD_ROLLBACK_PLANS + BEGIN);
export const loadRollbackPlansSuccessful = createAction(ROLLBACK_VERSION_MODULE + LOAD_ROLLBACK_PLANS + SUCCESSFUL);
export const loadRollbackPlansFailed = createAction(ROLLBACK_VERSION_MODULE + LOAD_ROLLBACK_PLANS + FAILED);
export const loadRollbackPlansClear = createDeferredAction(ROLLBACK_VERSION_MODULE + LOAD_ROLLBACK_PLANS + CLEAR);
